import { ChangeEvent, useState } from 'react';
import useLocationQuery from './hooks/useLocationQuery';
import { Input } from '@/src/tailwindui/input';

export default function LocationField(props: any) {
    const [locations, setLocations] = useState<string[]>([]);
    const { getLocations } = useLocationQuery();

    const onLocationChange = async (e: ChangeEvent) => {
        // @ts-ignore
        const value = e.target?.value;

        // set value in callback
        if (!value) {
            return;
        }

        const response = await getLocations(value);

        if (Array.isArray(response?.features)) {
            setLocations(
                response.features.map(
                    (place: { place_name: string }) => place.place_name,
                ),
            );
        }
    };

    return (
        <div className="expand flex monospace-font">
            <Input
                list="locations"
                type="text"
                id="location"
                name="location"
                onChange={onLocationChange}
                autoComplete="on"
                value={null}
                {...props}
                className="monospace-font text-[#000000] dark:text-[#FFFFFF]"
            />
            <datalist id="locations">
                {locations.map((location: string, i: number) => {
                    return <option key={i}>{location}</option>;
                })}
            </datalist>
        </div>
    );
}
